import { render, staticRenderFns } from "./MachineryProfile.vue?vue&type=template&id=98cd2f04&scoped=true"
import script from "./MachineryProfile.vue?vue&type=script&lang=ts"
export * from "./MachineryProfile.vue?vue&type=script&lang=ts"
import style0 from "./MachineryProfile.vue?vue&type=style&index=0&id=98cd2f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cd2f04",
  null
  
)

export default component.exports